import NextHead from 'next/head';

export const JsonLd: FC<{ data: AnyObject }> = ({ data }) => (
    <NextHead>
        <script
            dangerouslySetInnerHTML={{
                // escape `<` so the payload cannot break out of the script tag
                __html: JSON.stringify(data).replace(/</g, '\\u003c'),
            }}
            type='application/ld+json'
        />
    </NextHead>
);

// CMS returns dates as "YYYY-MM-DD HH:MM:SS" (Moscow time), "0000-00-00 00:00:00" means no date
export const formatCmsDate = (date?: string): string | null =>
    date && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(date) && !date.startsWith('0000')
        ? `${date.replace(' ', 'T')}+03:00`
        : null;
